import { TECHNICIAN_ERROR_MESSAGES } from '../errors/errorMessages';

/**
 * Upload file to S3 using presigned URL
 */
export const uploadFileToS3 = async (
  url: string,
  file: File
): Promise<void> => {
  try {
    const response = await fetch(url, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });

    if (!response.ok) {
      throw new Error(TECHNICIAN_ERROR_MESSAGES.UNEXPECTED_ERROR);
    }
  } catch (_error) {
    throw new Error(TECHNICIAN_ERROR_MESSAGES.UNEXPECTED_ERROR);
  }
};
